import axios from 'axios';
import { themeConfig } from '../config/theme';

// Create axios instance for dashboard
const API = axios.create({
  baseURL: themeConfig.apiUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    // Add web platform headers for version enforcement
    'x-platform': 'web',
    'x-version': '1.0.0',
  },
});

// Add request interceptor to ensure headers are always present
API.interceptors.request.use(
  async (config) => {
    // Ensure web platform headers are always set
    config.headers['x-platform'] = 'web';
    config.headers['x-version'] = '1.0.0';
    
    // Add authentication token if available
    try {
      // Import dynamically to avoid circular dependency
      const authService = require('./authService').default;
      const user = authService.getCurrentUser();
      if (user && user.token) {
        config.headers['Authorization'] = 'Bearer ' + user.token;
      }
    } catch (error) {
      console.log('Error getting auth token:', error);
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle version update requirements
API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check if the error is due to version requirements
    if (error.response?.status === 426 && error.response?.data?.requiresUpdate) {
      // This is a version update requirement error
      console.log('Version update required:', error.response.data);
      // For web, this shouldn't happen, but log it for debugging
    }
    return Promise.reject(error);
  }
);

export default API; 